import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Payment_Mode_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Payment_Mode_Report() {
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [transactionMode, setTransactionMode] = useState("bank_transfer");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    setPaymentData([]);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        user_id: localStorage.getItem("user_id") || 14857,
        transaction_mode: transactionMode,
      };

      const response = await simplePostCall(
        ApiConfig.paymentmodereportports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setPaymentData(response.data || []);
      } else {
        setPaymentData([]);
      }
    } catch (error) {
      console.error("Error fetching payment mode report:", error);
      setPaymentData([]);
    } finally {
      setLoading(false);
    }
  }, [transactionMode]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchInitialData();
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Payment Mode Report</h4>
        <button className="btn btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            className="form-select"
            value={transactionMode}
            onChange={(e) => setTransactionMode(e.target.value)}
          >
            <option value="">Select Mode</option>
            <option value="cash">Cash</option>
            <option value="bank_transfer">Bank Transfer</option>
            <option value="cheque">Cheque</option>
            <option value="dd">DD</option>
          </select>
          <button
            className="btn btn-primary"
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Paid By User</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Grade/Div</div>
            <div className="yc-list-cell">Transaction Id</div>
            <div className="yc-list-cell">Amount</div>
            <div className="yc-list-cell">Mode</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : paymentData.length > 0 ? (
          <div className="yc-list-row-list">
            {paymentData.map((item, index) => (
              <div key={item.transaction_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-7">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{item.paid_by_user}</div>
                  <div className="yc-list-cell">{item.student_name}</div>
                  <div className="yc-list-cell">
                    {item.grade} ({item.division})
                  </div>
                  <div className="yc-list-cell">
                    <strong>{item.transaction_id}</strong>
                  </div>
                  <div className="yc-list-cell">{formatNumber(item.transaction_amount)}</div>
                  <div className="yc-list-cell">
                    <span className="yc-status yc-status--info">
                      {item.transaction_mode.replace("_", " ")}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No results found for this payment mode.</div>
        )}
      </div>
    </div>
  );
}

export default Payment_Mode_Report;
